"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATATYPE_OBJECT = exports.DATATYPE_ARRAY = exports.SORT_DIRECTION_DESC = exports.SORT_DIRECTION_ASC = exports.COMPACT_MODE_WIDTH = exports.BLACKLISTED_HEADERS = void 0;
var BLACKLISTED_HEADERS = ['__typename'];
exports.BLACKLISTED_HEADERS = BLACKLISTED_HEADERS;
var COMPACT_MODE_WIDTH = 644;
exports.COMPACT_MODE_WIDTH = COMPACT_MODE_WIDTH;
var SORT_DIRECTION_ASC = 'ASC';
exports.SORT_DIRECTION_ASC = SORT_DIRECTION_ASC;
var SORT_DIRECTION_DESC = 'DESC';
exports.SORT_DIRECTION_DESC = SORT_DIRECTION_DESC;
var DATATYPE_ARRAY = 'array';
exports.DATATYPE_ARRAY = DATATYPE_ARRAY;
var DATATYPE_OBJECT = 'object';
exports.DATATYPE_OBJECT = DATATYPE_OBJECT;